<template>
	<div>
		<v-row       
			justify="center"
		>
			<v-col cols="8">
				<v-tabs
					fixed-tabs
					height=80px
					background-color="transparent"
					v-model="selectedTab"
					show-arrows
					:slider-color="'primary' "
					:color="'primary'"
				>
					<v-tab id="tab-historico" @click="changeDatatable('pre');">
						<span>
							<!--div>
								<v-icon class="icon-tab mb-2">mdi-history</v-icon>
							</div-->
							Pré Importação
						</span>
					</v-tab>

					<v-tab id="tab-favoritos" @click="changeDatatable('impo');">
						<span>
							Importação
						</span>
					</v-tab>
				</v-tabs>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<pre-importacao-table
					v-if="display == 'pre'"
					:items="itemsPre"
					:loading="loadingPre"
					:progresso="progressoPreImportacoes"
					@recharge="getPreImportacoes()"
					@recharge-importacoes="getImportacoes()"
				/>
				<importacao-table
					v-else
					:items="items"
					:loading="loading"
					:progresso="progressoImportacoes"
					@recharge="getImportacoes()"
				/>
			</v-col>
		</v-row>
	</div>
  </template>
  <script>
  import tourMixins from '@/mixins/tourMixins';
  import pusherMixins from '@/mixins/pusherMixins';
  import PreImportacaoDadosService from '@/services/PreImportacoesDadosService';
  import ImportacaoDadosService from '@/services/ImportacoesDadosService';
  
  export default {
	mixins: [pusherMixins, tourMixins],
  
	components: {
	  PreImportacaoTable: () => import("@/components/importacoesDados/administracao/PreImportacaoTable.vue"),
		ImportacaoTable: () => import("@/components/importacoesDados/administracao/ImportacaoTable.vue"),
	},
  
	mounted() {
	  this.getPreImportacoes();
		this.getImportacoes();
		this.subscribe();
	},

	beforeDestroy() {
		clearTimeout(this.refreshTimeout);
		if (this.refreshHandler) this.pusherChannel.unbind('refresh', this.refreshHandler);
		if (this.progressHandler) this.pusherChannel.unbind('progress', this.progressHandler);
	},
  
	data: () => ({
		selectedTab: 0,
		itemsPre: [],
	  items: [],
		display: 'pre',
	  loadingPre: false,
		loading: false,
		progressoPreImportacoes: {},
		progressoImportacoes: {},
		refreshTimeout: null,
		refreshHandler: null,
		progressHandler: null,
	}),
  
	methods: {
		subscribe() {
			this.refreshHandler = () => this.refreshImportacoesDados();
			this.progressHandler = data => this.updateProgress(data);
			this.pusherChannel.bind('refresh', this.refreshHandler);
			this.pusherChannel.bind('progress', this.progressHandler);
		},
		refreshImportacoesDados() {
			clearTimeout(this.refreshTimeout);
			this.refreshTimeout = setTimeout(() => {
				this.getPreImportacoes();
				this.getImportacoes();
			}, 300);
		},
		updateProgress(data) {
			if (!data || !data.id || !data.message) return;

			if (data.tipo === 'pre-importacao') {
				this.$set(this.progressoPreImportacoes, data.id, data.message);
			}

			if (data.tipo === 'importacao') {
				this.$set(this.progressoImportacoes, data.id, data.message);
			}
		},
		changeDatatable(type) {
			this.display = type
		},
		getPreImportacoes() {
			this.loadingPre = true;
			PreImportacaoDadosService.getPreimportacoes()
			.then((resp) => this.itemsPre = resp.data.data)
			.catch(() => this.$toast.error(`Erro ao buscar pre importações.`, '', {position: 'topRight'}))
			.finally(() => {
				this.loadingPre = false;
			});
	  },
		getImportacoes() {
			this.loading = true;
			ImportacaoDadosService.getImportacoesDados()
			.then((resp) => this.items = resp.data.data)
			.catch(() => this.$toast.error(`Erro ao buscar importações.`, '', {position: 'topRight'}))
			.finally(() => {
				this.loading = false;
			});
	  },
	}
  }
  </script>
